<div class="flex align-items-center justify-content-center font-bold m-2 text-3xl title-case">
    Partner Specific Configuration
</div>

<div class="mb-2">
    <p-card>
        <div class="formgroup-inline flex align-items-center justify-content-center font-bold">
            <div class="field">
                <label for="partnerId" class="required-field">Partner ID :</label>
                <p-dropdown [filter]="true" name="partnerId" placeholder="Select Partner ID" [options]="partnerDetails"
                    optionLabel="partnerId" (onChange)="onChangePartnerId($event)">
                </p-dropdown>
            </div>
            <div class="field">
                <input type="text" pInputText name="partnerName" value="{{selectedPartnerName}}" disabled class="custom-width">
            </div>
        </div>

        <!-- <div class="flex align-items-center justify-content-center font-bold">
            <button pButton type="button" label="Fetch Partner Details" class="" (click)="getPartnerConfigurationById()"
                [disabled]="disableButton"></button>
        </div> -->
    </p-card>
</div>

<p-card *ngIf="isDataAvailable">
    <div class="mb-4">
        <p-card>
            <form [formGroup]="partnerSpecificForm">
                <div class="flex justify-content-start flex-wrap font-bold mb-3">
                    UCM Resend Limitations (per Unit)
                </div>
                <div class="formgroup-inline">
                    <div class="field">
                        <label for="noOfResends" class="">Maximum Number of Resends :</label>
                        <p-inputNumber formControlName="noOfResends" inputId="withoutgrouping" [useGrouping]="false"
                            (onInput)="onChangeResendLimitations($event)">
                        </p-inputNumber>
                        <div *ngIf="!partnerSpecificForm.controls['noOfResends'].valid && partnerSpecificForm.controls['noOfResends'].dirty"
                            class="error-msg">
                            <div *ngIf="partnerSpecificForm.controls['noOfResends']?.hasError('required')"
                                class="error-msg">
                                Number Of Resend is required</div>
                            <div *ngIf="partnerSpecificForm.controls['noOfResends']?.hasError('pattern')"
                                class="error-msg">
                                Number Of Resend should be positive integer</div>
                            <div
                                *ngIf="partnerSpecificForm.controls['noOfResends']?.hasError('max') && !partnerSpecificForm.controls['noOfResends']?.hasError('pattern')">
                                Number Of Resend should have 1000 as maximum</div>
                        </div>

                    </div>
                    <div class="field">
                        <label class="">per :</label>
                        <p-dropdown [filter]="true" name="resends" [options]="frequencyLimitUnitsForResend"
                          formControlName="perResendUnit"
                            (onChange)="onChangeInput(partnerSpecificForm.value)"></p-dropdown>
                    </div>
                </div>

                <div class="flex justify-content-start flex-wrap font-bold mb-3">
                    Test Activation Limitations (per Unit)
                </div>
                <div class="formgroup-inline">
                    <div class="field">
                        <label for="maxTestActivation" class="">Maximum Number of Test Activations :</label>
                        <p-inputNumber formControlName="maxTestActivation" inputId="withoutgrouping"
                            [useGrouping]="false" (onInput)="onChangeActivationLimitations($event)">
                        </p-inputNumber>
                        <div *ngIf="!partnerSpecificForm.controls['maxTestActivation'].valid && partnerSpecificForm.controls['maxTestActivation'].dirty"
                            class="error-msg">
                            <span *ngIf="partnerSpecificForm.controls['maxTestActivation']?.hasError('required')">
                                Test Activation is required</span>
                            <span *ngIf="partnerSpecificForm.controls['maxTestActivation']?.hasError('pattern')">
                                Test Activation should be positive integer</span>
                            <span *ngIf="partnerSpecificForm.controls['maxTestActivation']?.hasError('max')">
                                Number Of Test Activation should have 1000 as maximum</span>

                        </div>
                    </div>
                    <div class="field">
                        <label class="">per :</label>
                        <p-dropdown [filter]="true" name="units" [options]="limitUnits"
                            formControlName="perTestUnit" [virtualScroll]="true"
                            (onChange)="onChangeInput(partnerSpecificForm.value)">
                        </p-dropdown>
                    </div>
                </div>
                <div class="flex justify-content-start flex-wrap  mt-3 mr-3">
                    <button pButton type="button" label="Update Limitations" class="btnClass"
                        [disabled]="!enableSaveDetails || partnerSpecificForm.invalid"
                        (click)="onUpdateLimitations()"></button>
                </div>
            </form>
        </p-card>
    </div>
    <p-card>
        <div class="flex justify-content-end flex-wrap mr-2">
            <button pButton pRipple type="button" label="Add Product" class="btnClass -mt-3"
                (click)="onAddNewProduct()"></button>
        </div>
        <div class="col-12 sm:col-12 md:col-12 lg:col-12 mb-3" *ngIf="!isProductDataAvailable">
            <p-table [value]="partnerConfigurationList" dataKey="productCode" styleClass="p-datatable-gridlines"
                editMode="row" scrollHeight="250px" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Product Code</th>
                        <th>Allowable Durations</th>
                        <th>Allowable Coverage Level</th>
                        <th class="w-2rem justify-content-center"></th>
                        <th class="w-2rem justify-content-center"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="product">
                        <td>
                            {{product.productCode}}
                        </td>
                        <td>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <p-multiSelect [filter]="true" [options]="durationResponse"
                                        [(ngModel)]="product.concatinatedList" optionLabel="concatinatedName"
                                        (onChange)="onChangeDuration($event,product)" appendTo="body" autoWidth="false"
                                        [style]="{'width':'260px'}" binary="true" [virtualScroll]="true">
                                    </p-multiSelect>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <span>
                                        {{product.sortedData}}
                                    </span>
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <p-multiSelect [filter]="true" [virtualScroll]="true"
                                        [(ngModel)]="product.coverageLevels" optionLabel="name"
                                        [options]="coverageLevelResponse" binary="true" autoWidth="false"
                                        [style]="{'width':'260px'}" appendTo="body"
                                        (onChange)="onChangeCoverageLevel($event, product)">
                                    </p-multiSelect>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <span>
                                        {{product.coverageData}}
                                    </span>
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td class="w-2rem justify-content-center">
                            <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                                (click)="onRowEditInit(product, ri)" class="p-button-rounded"></button>
                            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                                (click)="onRowEditSave(product)"
                                class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                                (click)="onRowEditCancel(product, ri)"
                                class="p-button-rounded p-button-text p-button-danger"
                                id="productcancel{{ri}}"></button>
                        </td>
                        <td class="w-2rem justify-content-center">
                            <button pButton pRipple type="button" icon="pi pi-trash" (click)="deleteProduct(product)"
                                class="p-button-rounded p-button-danger"></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div class="flex justify-content-center flex-wrap" *ngIf="isProductDataAvailable">
            <div class="flex align-items-center justify-content-center w-full font-bold border-round m-2 text-1xl">
                No Configuration Data Available
            </div>
        </div>
    </p-card>
</p-card>


<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" [ngClass]="{'errorcode':errorResponseCode}">
</p-confirmDialog>

<p-dialog appendTo="body" [(visible)]="productDialog" header="Add Product" [draggable]="false"
    [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}" [modal]="true"
    styleClass="p-fluid;text-align:center;font-bold">
    <ng-template pTemplate="content">
        <form [formGroup]="newPartnerForm" class="">
            <div class="field">
                <label for="productCode" class="required-field">Product Code :</label>
                <p-inputMask formControlName="productCode" mask="9999-99-9" autoWidth="false" autoWidth="false"
                    [style]="{'width':'100%'}"></p-inputMask>

                <div *ngIf="!newPartnerForm.controls['productCode'].valid && newPartnerForm.controls['productCode'].dirty"
                    class="error-msg">
                    <span *ngIf="newPartnerForm.controls['productCode']?.hasError('required')" class="error-msg">
                        Product Code is required</span>
                </div>
            </div>
            <div class="field">
                <label for="duration" class="required-field">Allowable Durations : </label>
                <p-multiSelect optionLabel="concatinatedName" [virtualScroll]="true" id="duration"
                    [options]="durationResponse" placeholder="select durations" formControlName="duration"
                    autoWidth="false" appendTo="body" [style]="{'width':'100%'}"
                    (onChange)="onChangeProductDuration($event)" scrollHeight="200px">
                </p-multiSelect>
                <div *ngIf="!newPartnerForm.controls['duration'].valid && newPartnerForm.controls['duration'].dirty"
                    class="error-msg">
                    <span *ngIf="newPartnerForm.controls['duration']?.hasError('required')" class="error-msg">
                        Allowable Duration is required</span>
                </div>
            </div>


            <div class="field">
                <label for="duration" class="required-field">Allowable Coverage Level : </label>
                <p-multiSelect [filter]="true" optionLabel="name" id="coverageLevel" [options]="coverageLevelResponse"
                    placeholder="select coverage level" formControlName="coverageLevel" autoWidth="false"
                    appendTo="body" (onChange)="onChangeProductCoverageLevel($event)" [style]="{'width':'100%'}"
                    scrollHeight="200px">
                </p-multiSelect>
                <div *ngIf="!newPartnerForm.controls['coverageLevel'].valid && newPartnerForm.controls['coverageLevel'].dirty"
                    class="error-msg">
                    <span *ngIf="newPartnerForm.controls['coverageLevel']?.hasError('required')" class="error-msg">
                        Allowable CoverageLevel is required</span>
                </div>
            </div>

            <div class="flex justify-content-center flex-wrap">
                <div class="flex align-items-center justify-content-center w-5rem h-4rem font-bold border-round m-4">
                    <button pButton type="button" label="Cancel" (click)="cancelDetails()" class="p-button-danger"
                        style="min-width: 100px"></button>
                </div>
                <div class="flex align-items-center justify-content-center w-5rem h-4rem font-bold border-round m-4">
                    <button pButton type="button" label="Save" (click)="saveNewProductDetails()" class="btnClass"
                        style="min-width: 100px" [disabled]="newPartnerForm.invalid"></button>
                </div>

            </div>
        </form>
    </ng-template>
</p-dialog>
<p-toast position="top-center" life="4000"></p-toast>